export default __webpack_public_path__ + "public/assets/fonts/76a4f23c6be74fd309e0d0fd2c27a5de.svg";